import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useMutateData } from "../../hooks/useMutateData";
import { useFetchData } from "../../hooks/useFetchData";

const CreateReconciliationAction = ({
  show,
  hide,
  operatorId,
  reconciliationId,
}) => {
  const [payload, setPayload] = useState({});
  const fetchUrl = `operators/reconciliations/actions`;
  const { data: actions } = useFetchData(
    ["reconciliation-actions"],
    fetchUrl,
    true
  );
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPayload({
      ...payload,
      [name]: value,
    });
  };
  const { mutate } = useMutateData();
  const createAction = async (e) => {
    e.preventDefault();
    const postUrl = `operators/reconciliations/${reconciliationId}/actions`;
    const successMessage = "Reconciliation action created";
    try {
      const dataToSend = {
        ...payload,
        reconciliationId,
      };
      await mutate({
        url: postUrl,
        payload: dataToSend,
        queryKeyToInvalidate: ["recon-details", "reconciliation-details"],
        successMessage,
        method: "POST",
        closeModal: hide,
      });
    } catch (error) {
      // Handle errors
      console.log(error);
    }
  };
  return (
    <div>
      <Modal
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={hide}>
          <Modal.Title>Create Reconciliation Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={createAction}>
            <label className='ml-2 mt-2'>operator Id</label>
            <input
              type='text'
              className='form-control'
              placeholder='Type amount'
              name='operatorId'
              value={operatorId}
              required
              readOnly
            />
            <label className='ml-2 mt-2'>Reconciliation Id</label>
            <input
              type='text'
              className='form-control'
              placeholder='Type amount'
              name='reconciliationPeriod'
              value={reconciliationId}
              required
              readOnly
            />
            <label className='ml-2 mt-2'>Reconcilitation Action</label>
            <select
              className='form-control'
              name='typeId'
              onChange={handleInputChange}
              required
            >
              <option value=''>Select action</option>
              {actions?.map((action) => (
                <option value={action.id} key={action.id}>
                  {action.name}
                </option>
              ))}
            </select>
            <label className='ml-2 mt-2'>Action Description</label>
            <textarea
              placeholder='Enter reason'
              className='form-control mt-2'
              required
              name='actionInfo'
              onChange={handleInputChange}
            />
            <Button className='custom-btn-color' type='submit'>
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateReconciliationAction;
